/* eslint-disable no-unused-expressions */

export const initializeGlobalVariable = () => {
  window.cbEnv = process.env.ENV;
  window.cbEnvLower = Boolean(process.env.ENV !== 'prod');
};

export const SATELLITE_MAPPING = {
  STUDENT_SEARCH_SERVICES_OPT_IN: 'bfVcfTrack.sssOptin',
  STUDENT_SEARCH_SERVICES_OPT_OUT: 'bfVcfTrack.sssOptout'
};

export const track = event => {
  try {
    if (typeof _satellite !== 'undefined') {
      _satellite.track(event);
    }
  } catch (error) {
    return error;
  }
};

/**
   * Function which merges adl and fires the track event
   * @param {object} application data layer obj
   */
export function mergeAndTrack({
  pageCode = '', // When passed in, its an object else set to empty string
  appViewCode = '', // When passed in, its an object else set to empty string
  isLoading = false, // Boolean
  searchData = {} // This will be an object passed by the caller
}) {
  const applicationDataLayer = {
    page: {
      pageCode,
      appViewCode,
      isLoading,
      searchData
    }
  };
  //Updated to use ACDL Push Method 
  //https://collegeboard.atlassian.net/wiki/spaces/wa/pages/75419728/Tracking+Pages
  try {_satellite.track('cbTrack.viewInDom');}
  catch(errSatelliteTrack) {}
}